export default __webpack_public_path__ + "static/media/404.ad8a1057.png";